import { render, staticRenderFns } from "./TelegramChatNews.vue?vue&type=template&id=3bfc09e1&scoped=true"
import script from "./TelegramChatNews.vue?vue&type=script&lang=js"
export * from "./TelegramChatNews.vue?vue&type=script&lang=js"
import style0 from "./TelegramChatNews.vue?vue&type=style&index=0&id=3bfc09e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfc09e1",
  null
  
)

export default component.exports